<div class="distribution-options" [attr.aria-busy]="busy">
  <div *ngIf="loading" class="distribution-options__state color-gray-dark">
    <app-loader [size]="'small'" [position]="'reset'"></app-loader>
    <span>Загрузка настроек…</span>
  </div>

  <div *ngIf="!loading && loadError" class="color-red-dark">
    {{ loadError }}
    <button type="button" class="button ml-8" id="sectorDistributionOptionsRetry" (click)="load()">Повторить</button>
  </div>

  <ng-container *ngIf="!loading && !loadError">
    <div class="distribution-options__status color-gray-dark mb-16">
      {{ hasSavedOptions ? 'Для участка сохранены настройки.' : 'Настройки не сохранены — используются значения по умолчанию.' }}
    </div>

    <div class="distribution-options__option mb-16">
      <app-checkbox>
        <input
          type="checkbox"
          id="sectorOptionAutoassigned"
          [checked]="options.autoassigned"
          [disabled]="busy"
          (change)="setAutoassigned($event.target.checked)"
        />
        <checkbox-text>Автоматическое распределение включено</checkbox-text>
      </app-checkbox>
    </div>

    <div class="distribution-options__layout" [class.distribution-options__layout--disabled]="!options.autoassigned">
      <div class="distribution-options__column">
        <div class="title title--s mb-8">Тип отображения</div>
        <div class="distribution-options__option">
          <app-radio-button>
            <input
              type="radio"
              id="sectorOptionAssignAfterResultPreview"
              name="sectorOptionAssignAfterResult"
              [checked]="!options.assignAfterResult"
              [disabled]="true"
              (change)="setAssignAfterResult(false)"
            />
            <radio-button-text>Предпросмотр</radio-button-text>
          </app-radio-button>
        </div>
        <div class="distribution-options__option">
          <app-radio-button>
            <input
              type="radio"
              id="sectorOptionAssignAfterResultAssign"
              name="sectorOptionAssignAfterResult"
              [checked]="options.assignAfterResult"
              [disabled]="fieldsDisabled"
              (change)="setAssignAfterResult(true)"
            />
            <radio-button-text>Распределить и Сохранить</radio-button-text>
          </app-radio-button>
        </div>

        <div class="title title--s mb-8 mt-16">Стратегия распределения</div>
        <div class="distribution-options__option" *ngFor="let strategy of strategies">
          <app-radio-button>
            <input
              type="radio"
              [id]="'sectorOptionStrategy-' + strategy.value"
              name="sectorOptionDistributionStrategy"
              [checked]="options.distributionStrategy === strategy.value"
              [disabled]="fieldsDisabled"
              (change)="setDistributionStrategy(strategy.value)"
            />
            <radio-button-text>{{ strategy.label }}</radio-button-text>
          </app-radio-button>
          <span class="distribution-options__info" [ngbPopover]="strategy.hint" triggers="mouseenter:mouseleave" placement="right">i</span>
        </div>
      </div>

      <div class="distribution-options__column">
        <div class="title title--s mb-8">Распределение по районам</div>
        <div class="distribution-options__option" *ngFor="let limitation of limitationTypes">
          <app-radio-button>
            <input
              type="radio"
              [id]="'sectorOptionLimitationType-' + limitation.value"
              name="sectorOptionLimitationType"
              [checked]="options.limitationType === limitation.value"
              [disabled]="fieldsDisabled"
              (change)="setLimitationType(limitation.value)"
            />
            <radio-button-text>{{ limitation.label }}</radio-button-text>
          </app-radio-button>
          <span
            *ngIf="limitation.hint"
            class="distribution-options__info"
            [ngbPopover]="limitation.hint"
            triggers="mouseenter:mouseleave"
            placement="right"
            >i</span
          >
        </div>

        <div class="title title--s mb-8 mt-16">
          <label for="sectorOptionAllowedOrderOverlapMinutes">Допустимое пересечение заявок, мин</label>
        </div>
        <div class="distribution-options__option">
          <input
            type="number"
            class="input-text distribution-options__number"
            id="sectorOptionAllowedOrderOverlapMinutes"
            [min]="overlapMinutesMin"
            [max]="overlapMinutesMax"
            step="1"
            [value]="options.allowedOrderOverlapMinutes"
            [disabled]="fieldsDisabled"
            (change)="onAllowedOrderOverlapMinutesChange($event)"
          />
          <span
            class="distribution-options__info"
            [ngbPopover]="'На сколько минут могут пересекаться по времени заявки одного сотрудника. 0 — без пересечений.'"
            triggers="mouseenter:mouseleave"
            placement="right"
            >i</span
          >
        </div>
      </div>
    </div>

    <div class="distribution-options__actions mt-16">
      <button type="button" class="button" id="sectorDistributionOptionsSave" [disabled]="busy" (click)="save()">
        {{ saving ? 'Сохранение…' : hasSavedOptions ? 'Сохранить настройки' : 'Создать настройки' }}
      </button>
      <a
        *ngIf="hasSavedOptions"
        class="link link--dotted-blue-dark"
        id="sectorDistributionOptionsDelete"
        [class.distribution-options__link--disabled]="busy"
        (click)="confirmDelete()"
        >{{ deleting ? 'Удаление…' : 'Удалить настройки' }}</a
      >
    </div>

    <div *ngIf="actionError" class="color-red-dark mt-8" aria-live="polite">{{ actionError }}</div>
    <div *ngIf="successMessage" class="color-green-dark mt-8" aria-live="polite">{{ successMessage }}</div>
  </ng-container>
</div>
